import Vue from 'vue'
import App from './App.vue'
import { Message, Dialog, Input, Button, Form, FormItem, Select, Option } from 'element-ui'

Vue.config.productionTip = false;

Vue.use(Dialog);
Vue.use(Input);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.prototype.$message = Message;

new Vue({
  render: h => h(App),
}).$mount('#app')
